const userInfo = {
  state: () => {},
  mutations: {},
  actions: {},
  getters: {}
};
export default userInfo;
